import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ProfileTypeService } from '../../../../../core/services/contact/contact-type/contact-type.service'
import { NgxMaskDirective } from 'ngx-mask'
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from '@angular/material/timepicker';
import {NgForOf} from '@angular/common';
import {
  MedicalInsuranceService
} from '../../../../../core/services/medical-insurance/municipality/medical-insurance.service';

@Component({
  selector: 'medical-insurance-patient-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    NgForOf,
  ],
  templateUrl: './medical-insurance-patient-form.component.html',
  styleUrl: './medical-insurance-patient-form.component.scss',
  providers: [ProfileTypeService],
  standalone: true,
})
export class MedicalInsurancePatientFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private medicalInsuranceService: MedicalInsuranceService,
  ) {}
  diasSemanaList: any[] = []
  messagesList: any[] = []
  timeList: any[] = []
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []

  ngOnInit(): void {
  //  this.getListType()
    this.createForm()
    this.getConvenios()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }
  getConvenios(){
    this.medicalInsuranceService.listActiveMunicipality().subscribe({
      next: (response: ResponseRequestModel) => {
        this.messagesList = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }
  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  // getListType() {
  //   this.contactTypeService.listContactType().subscribe({
  //     next: (response: ResponseRequestModel) => {
  //       this.listType = response.data
  //     },
  //     error: (err: ResponseRequestModel) => {
  //       console.error(err)
  //     },
  //     complete: () => {},
  //   })
  // }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('identif')?.setValue(this.editItem.num_identificacao)
    this.form.get('medInsurance')?.setValue(this.editItem.id_convenio)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      identif: ["", [Validators.required]],
      medInsurance: [null, [Validators.required]],
    })
  }

  // getTypeDescription() {
  //   let typeId = this.form.get('typeContact')?.value
  //   if (typeId) {
  //     let element = this.listType.find((ele: any) => {
  //       return ele.id === typeId
  //     })
  //     return element.descricao
  //   } else {
  //     return ''
  //   }
  // }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    const selectedId = this.form.controls['medInsurance'].value;
    const selectedConvenio = this.messagesList.find((c: any) => c.id === selectedId);

    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        id_convenio: selectedId,
        num_identificacao: this.form.controls['identif']?.value,
        convenio_descricao: selectedConvenio?.descricao ?? '',
      };
    } else {
      return {
        id_convenio: selectedId,
        num_identificacao: this.form.controls['identif']?.value,
        convenio_descricao: selectedConvenio?.descricao ?? '',
      };
  }
}
}
